export default __webpack_public_path__ + "static/media/simProfile-11.841d0507.png";